import Vue from 'vue'
import App from './App.vue'
//全局适用axios
import axios from 'axios'
Vue.prototype.$http = axios
import router from './router'
import store from './store'
import './services/xhr'
// 进度条
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

//引入重置样式
import './assets/css/reset.css'

//引入rem计算方法
import './utils/rem.js'

//引入拦截器
import './api/request'

// import md5 from 'js-md5';
// Vue.prototype.$md5 = md5;

//全局适用storejs
import storejs from "store";
Vue.prototype.$storejs = storejs
Vue.config.productionTip = false
// 当前环境
Vue.prototype.$env = process.env.NODE_ENV
// 当前的 baseUrl
Vue.prototype.$baseUrl = process.env.BASE_URL
// 当前版本
Vue.prototype.$version = process.env.VUE_APP_VERSION
// 构建时间
Vue.prototype.$buildTime = process.env.VUE_APP_BUILD_TIME

//全局使用filter
import '@/filters/index.js'

import Router from 'vue-router'
 
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

import { SwipeCell } from 'vant';
Vue.use(SwipeCell);
import { Popup,Form,Field  } from 'vant';
Vue.use(Popup);
Vue.use(Form)
Vue.use(Field)

//引入jq
import $ from "jquery";
window.$ = $
var wx = require("weixin-js-sdk");
window.wx = wx

//引入toast清提示并挂载全局
import {
  Toast
} from 'vant';
Vue.use(Toast);
Vue.prototype.$toast = Toast

// import Container from '@/components/Container';
//全局引入一日历
import Calendar from 'vue-mobile-calendar'
Vue.use(Calendar)
Vue.config.productionTip = false


//判断运行环境
const u = navigator.userAgent;
let page = {
  isInApp: u.indexOf('Finger') !== -1 || u.indexOf('finger') !== -1, // 是否在app中
  isInWechat: u.indexOf('MicroMessenger') !== -1 && u.indexOf('wxwork') === -1, // 在普通微信中
  isInMiniprogram: window.__wxjs_environment === "miniprogram", // 是否在小程序中
  isAndroid: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, // 是否是安卓
  isIOS: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //是否是ios
  bridge:window.WebViewJavascriptBridge
}
Vue.prototype.$page = page


import util from '@/libs/util.js'
router.beforeEach(async (to, from, next) => {
  // 验证当前路由所有的匹配中是否需要有登录验证的
  // 进度条
  NProgress.start()
  if (to.matched.some(r => r.meta.auth)) {
    // 这里暂时将cookie里是否存有token作为验证是否登录的条件
    const token = util.cookies.get('token')
    if (token && token !== 'undefined') {
      await store.dispatch('d2admin/account/load')
      next()
    } else {
      // 删除cookie
      util.cookies.remove("token");
      util.cookies.remove("uuid");
      // 跳转路由
      localStorage.clear();
      // 没有登录的时候跳转到登录界面
      // 携带上登陆成功之后需要跳转的页面完整路径
      next({
        name: 'Login',
        query: {
          redirect: 'index'
        }
      })
    }
  } else {
    // 不需要身份校验 直接通过
    await store.dispatch('d2admin/account/load')
    next()
  }
})

router.afterEach((to, form) => {
  NProgress.done()
  //路由变换后自动滚到顶部
  window.scroll(0, 0);
  document.body.scrollIntoView(true);
  //判断当前路由和路由表里的路由给页面设置标题
  router.history.router.options.routes.forEach(el => {
    if (el.title && el.name == router.history.current.name) {
      document.title = el.title
    }
  })
})
new Vue({
  store,
  router,
  render: h => h(App),
  created () {
    console.log('$store',this.$store)
  },
  async mounted () {
    await this.$store.dispatch('d2admin/account/load')
  },
  methods: {
  }
}).$mount('#app')